export default "__VITE_ASSET__DwB2VMFs__"